import React, { useState } from 'react';
import { SpinRoulette } from './../../../utilities/BL/Roulette';


const Roulette = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const screenId = parseInt(queryParams.get('screenId') || 1, 10);

    const [isSpinning, setIsSpinning] = useState(false);
    const [toast, setToast] = useState('');

    const showToast = (msg) => {
        setToast(msg);
        setTimeout(() => setToast(''), 3000);
    };

    const handleSpinClick = async () => {
        if (isSpinning) return;
        setIsSpinning(true);
        showToast('¡Girando la ruleta! Mira la pantalla grande... 🎡');

        try {
            // Mandamos el tiro directamente con un nombre por defecto
            await SpinRoulette({
                targetScreenId: screenId,
                playerName: "Aficionado",
                playerContact: ""
            });

            // Bloqueamos el botón por 7 segundos en lo que la ruleta física termina de girar
            setTimeout(() => {
                setIsSpinning(false);
                showToast('¡Listo para intentar de nuevo!');
            }, 7000);

        } catch (error) {
            showToast('❌ Error de conexión al girar');
            setIsSpinning(false);
        }
    };

    return (
        <>
            <div className='SelfieFan__Screen__QR__Background'>
                <video 
                    src='/img/page/backgrounds/Fondo-SelfieFan-Varonil-Cadenas-Zoom-Master-2.mp4' 
                    className='SelfieFan__Screen__QR__Background__Video' 
                    autoPlay loop muted playsInline 
                />

                {/* <img src='/img/page/backgrounds/background-womens-day-2026-bold.png' className='SelfieFan__Screen__QR__Background__Video' /> */}
            </div>

            <div style={{ position: 'relative', width: '100vw', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', padding: '40px 20px' }}>
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <img src="/img/page/xolos-five.png" alt="Logo" style={{ maxWidth: '180px', marginBottom: '10px' }} />
                    <p style={{ color: '#888', margin: 0, color: '#fff' }}>Conectado a la Pantalla #{screenId}</p>
                </div>

                {/* BOTÓN CENTRAL DE DISPARO INTERACTIVO ESTILO CASINO */}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <button 
                        disabled={isSpinning}
                        onClick={handleSpinClick}
                        style={{
                            width: '200px', height: '200px', borderRadius: '50%',
                            background: isSpinning ? '#444' : '#dc2626', //linear-gradient(145deg, #ffc107, #ff9800)
                            border: '10px solid #1a1a1a', color: isSpinning ? '#aaa' : '#111',
                            fontSize: '2rem', fontWeight: 'black', textTransform: 'uppercase',
                            boxShadow: isSpinning ? 'none' : '0 15px 30px rgba(255,152,0,0.4), inset 0 4px 10px rgba(255,255,255,0.4)',
                            cursor: isSpinning ? 'not-allowed' : 'pointer', transform: isSpinning ? 'translateY(4px)' : 'none',
                            transition: 'all 0.1s ease', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center',
                            color: '#fff'
                        }}
                    >
                        {isSpinning ? '🎡' : '¡GIRAR!'}
                    </button>
                    <p style={{ color: '#fff', marginTop: '30px', fontSize: '1.2rem', textAlign: 'center', opacity: 0.8 }}>
                        {isSpinning ? 'La ruleta está girando en la pantalla...' : '¡Toca el botón para jugar!'}
                    </p>
                </div>

                <p style={{ color: '#666', fontSize: '0.9rem', margin: 0, color: '#fff' }}>Hecho con ♥ por Interaktia | 2026</p>
                
                {toast && <div style={{ position: 'fixed', bottom: '40px', backgroundColor: 'rgba(0,0,0,0.9)', color: 'white', padding: '12px 25px', borderRadius: '30px', zIndex: 2000, border: '1px solid #ffb300' }}>{toast}</div>}
            </div>
        </>
    );
};

export { Roulette };









// import React, { useState } from 'react';
// import { SpinRoulette } from './../../../utilities/BL/Roulette'


// const Roulette = () => {
//     const queryParams = new URLSearchParams(window.location.search);
//     const screenId = parseInt(queryParams.get('screenId') || 1, 10);

//     const [isSpinning, setIsSpinning] = useState(false);
//     const [toast, setToast] = useState('');
//     const [playerName, setPlayerName] = useState('');
//     const [playerContact, setPlayerContact] = useState('');
//     const [hasRegistered, setHasRegistered] = useState(false);

//     const showToast = (msg) => {
//         setToast(msg);
//         setTimeout(() => setToast(''), 3000);
//     };

//     const handleRegister = (e) => {
//         e.preventDefault();
//         if (!playerName.trim()) {
//             showToast('Por favor, ingresa tu nombre');
//             return;
//         }
//         setHasRegistered(true);
//         showToast(`¡Listo ${playerName}! Presiona el botón para girar.`);
//     };

//     const handleSpinClick = async () => {
//         if (isSpinning) return;
//         setIsSpinning(true);
//         showToast('¡Girando la ruleta! Mira la pantalla grande... 🎡');

//         try {
//             const result = await SpinRoulette({
//                 targetScreenId: screenId,
//                 playerName: playerName || "Aficionado de la Suerte",
//                 playerContact: playerContact || ""
//             });

//             // Bloqueamos la pantalla del móvil por 7 segundos en lo que frena e impacta la animación física
//             setTimeout(() => {
//                 setIsSpinning(false);
//                 setHasRegistered(false);
//                 setPlayerName('');
//                 setPlayerContact('');
//             }, 7000);

//         } catch (error) {
//             showToast('❌ Error de conexión al girar');
//             setIsSpinning(false);
//         }
//     };

//     if (!hasRegistered) {
//         return (
//             <div style={{ position: 'relative', width: '100vw', height: '100vh', backgroundColor: '#111', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
//                 <div style={{ backgroundColor: '#1a1a1a', padding: '30px', borderRadius: '25px', width: '100%', maxWidth: '400px', textAlign: 'center', border: '2px solid #db166c', boxShadow: '0 10px 30px rgba(0,0,0,0.5)' }}>
//                     <i className="bi bi-person-vcard text-warning mb-3" style={{ fontSize: '4.5rem', display: 'block' }}></i>
//                     <h2 style={{ color: 'white', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '10px' }}>¡Gira y Gana!</h2>
//                     <p style={{ color: '#aaa', fontSize: '1rem', marginBottom: '30px' }}>Regístrate para liberar la ruleta de la fortuna.</p>
//                     <form onSubmit={handleRegister}>
//                         <input type="text" className="form-control form-control-lg mb-3" style={{ backgroundColor: '#222', color: 'white', border: '1px solid #db166c' }} placeholder="Tu Nombre" value={playerName} onChange={(e) => setPlayerName(e.target.value)} required />
//                         <input type="text" className="form-control form-control-lg mb-4" style={{ backgroundColor: '#222', color: 'white', border: '1px solid #db166c' }} placeholder="WhatsApp / Correo (Opcional)" value={playerContact} onChange={(e) => setPlayerContact(e.target.value)} />
//                         <button type="submit" className="btn btn-warning btn-lg w-100 fw-bold text-uppercase" style={{ fontSize: '1.3rem', borderRadius: '50px' }}>Entrar a Jugar</button>
//                     </form>
//                 </div>
//                 {toast && <div style={{ position: 'fixed', bottom: '40px', backgroundColor: 'rgba(0,0,0,0.9)', color: 'white', padding: '12px 25px', borderRadius: '30px', zIndex: 2000, border: '1px solid #ffb300' }}>{toast}</div>}
//             </div>
//         );
//     }

//     return (
//         <div style={{ position: 'relative', width: '100vw', height: '100vh', backgroundColor: '#111', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', padding: '40px 20px' }}>
//             <div style={{ textAlign: 'center', marginTop: '20px' }}>
//                 <img src="/img/page/xolos-five.png" alt="Logo" style={{ maxWidth: '180px', marginBottom: '10px' }} />
//                 <p style={{ color: '#888', margin: 0 }}>Conectado a la Pantalla #{screenId}</p>
//             </div>

//             {/* BOTÓN CENTRAL DE DISPARO INTERACTIVO ESTILO CASINO */}
//             <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
//                 <button 
//                     disabled={isSpinning}
//                     onClick={handleSpinClick}
//                     style={{
//                         width: '180px', height: '180px', borderRadius: '50%',
//                         background: isSpinning ? '#444' : 'linear-gradient(145deg, #ffc107, #ff9800)',
//                         border: '10px solid #1a1a1a', color: isSpinning ? '#aaa' : '#111',
//                         fontSize: '1.8rem', fontWeight: 'black', textTransform: 'uppercase',
//                         boxShadow: isSpinning ? 'none' : '0 15px 30px rgba(255,152,0,0.4), inset 0 4px 10px rgba(255,255,255,0.4)',
//                         cursor: isSpinning ? 'not-allowed' : 'pointer', transform: isSpinning ? 'translateY(4px)' : 'none',
//                         transition: 'all 0.1s ease', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center'
//                     }}
//                 >
//                     {isSpinning ? '🎡' : '¡GIRAR!'}
//                 </button>
//                 <p style={{ color: '#fff', marginTop: '30px', fontSize: '1.1rem', textAlign: 'center', opacity: 0.8 }}>
//                     {isSpinning ? 'La ruleta está girando en la pantalla...' : '¡Presiona el botón de la suerte!'}
//                 </p>
//             </div>

//             <p style={{ color: '#666', fontSize: '0.9rem', margin: 0 }}>Hecho con ♥ por Interaktia | 2026</p>
//             {toast && <div style={{ position: 'fixed', bottom: '40px', backgroundColor: 'rgba(0,0,0,0.9)', color: 'white', padding: '12px 25px', borderRadius: '30px', zIndex: 2000, border: '1px solid #ffb300' }}>{toast}</div>}
//         </div>
//     );
// };

// export { Roulette };